module.exports = "https://cdn.realtymogul.com/static/media/img_annual_dist.0733e4ea.png";